// // src/Components/Auth/ProtectedRoute.js
// import React from 'react';
// import { Navigate } from 'react-router-dom';

// const ProtectedRoute = ({ children }) => {
//   const isAuthenticated = localStorage.getItem('isAuthenticated'); // or use context

//   return isAuthenticated ? children : <Navigate to="/login" replace />;
// };

// export default ProtectedRoute;
// Components/ProtectedRoute/ProtectedRoute.js


import React from 'react';
import { Navigate } from 'react-router-dom';

const AdminProtectedRoute = ({ children }) => {
  const isAuthenticated1 = localStorage.getItem('isAuthenticatedAdmin'); // or check token, etc.
  return isAuthenticated1 ? children : <Navigate to="/adminlogin" replace />;
};

export default AdminProtectedRoute;
